import logo from '../img/swb-logo.png'
import error_img from '../img/error.png'
import sucess_img from '../img/t&c_accept.png'
import submit_error_img from '../img/t&c_fail.png'
import { useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import useAuth from '../hooks/useAuth'
import axios from '../api/axios'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'

function TermsConditions() {
  const { token } = useParams()
  const [success, setSuccess] = useState(false)
  const [client, setClient] = useState({})
  const [error, setError] = useState(false)
  const [accepted, setAccepted] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [submitError, setSubmitError] = useState(false)

  useEffect(() => {
    openedTerms()
  }, [])

  const { setShowLoader } = useAuth()

  const openedTerms = async () => {
    try {
      setShowLoader(true)
      const response = await axios.get(`/opened-terms/${token}`)
      if (response.data.error === true) {
        setError(true)
        setShowLoader(false)
        return
      }

      if (response.data.result) {
        await setClient(response.data.result)
      }
    } catch (error) {
      console.error(error)
    }

    setShowLoader(false)
  }

  const confirmTerms = async () => {
    try {
      setShowLoader(true)
      const response = await axios.get(`/confirm-terms/${client.id}`)
      if (!response.data.error) {
        await setSuccess(true)
      }
      if (!response.data.error) {
        setSuccess(true)
      } else {
        setSubmitError(true)
      }
    } catch (err) {
      setSubmitError(true)
    }
    setShowLoader(false)
  }

  return (
    <div className="px-4">
      {success || client?.terms?.accepted_terms === true ? (
        <div className="flex items-center justify-center h-screen bg-white space-x-8">
          <div className="text-left mt-4 text-[#407cb9] font-semibold text-3xl">
            Terms and conditions accepted <br></br> successfully.
          </div>
          <img src={sucess_img} alt="Accepted" className="w-1/3 mb-4" />
        </div>
      ) : submitError ? (
        <div className="flex items-center justify-center h-screen bg-white space-x-8">
          <div className="text-left mt-4 text-[#ab366a] font-semibold text-3xl">
            <div>Oops!</div>
            Something went wrong. <br></br> Please contact the School Wellbeing
            Team.
          </div>
          <img src={submit_error_img} alt="Failed" className="w-1/3 mb-4" />
        </div>
      ) : error ? (
        <section className="w-screen h-screen ">
          <img
            src={error_img}
            alt="404 Error Message. Can not find client"
            className="h-full"
          />
        </section>
      ) : (
        <div className="max-w-7xl mx-auto">
          <div className="flex justify-center my-16">
            <img src={logo} alt="" className="w-1/4" />
          </div>

          <div className="text-center mt-10 text-2xl">
            Please Accept the Terms and Conditions
          </div>

          <div
            style={{
              position: 'relative',
              paddingTop: '56.25%',
              height: 0,
              overflow: 'hidden',
            }}
          >
            <object
              data="https://schoolwellbeing.com/wp-content/uploads/2025/07/SWB-Information-and-Terms-for-Clients.pdf"
              type="application/pdf"
              width="100%"
              height="100%"
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
              }}
            >
              <p>
                Your browser does not support PDFs click below to view the T&Cs.
              </p>
            </object>
          </div>
          <a
            className="text-blue-500 hover:underline text-lg my-6"
            href="https://schoolwellbeing.com/wp-content/uploads/2025/07/SWB-Information-and-Terms-for-Clients.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            Can't see the T&Cs? click here
          </a>
          <div className="pt-6 pb-10">
            <div className="py-3 flex items-center">
              <input
                type="checkbox"
                className="h-6 w-6"
                id="termsCheckbox"
                onChange={(e) => setAccepted(e.target.checked)}
              />
              <label className="pl-4 text-lg" htmlFor="termsCheckbox">
                I have read and accept the terms and conditions
              </label>
            </div>
            <button
              onClick={confirmTerms}
              className={`btn shadow-lg w-full ${!accepted ? 'disabled cursor-not-allowed' : 'primary'
                }`}
              disabled={!accepted}
            >
              {isLoading ? (
                <FontAwesomeIcon icon={faSpinner} spin className="text-xl" />
              ) : (
                <span className="text-xl">Proceed</span>
              )}
            </button>
            {accepted && success && (
              <div className="text-center mt-4 text-teal-500 font-semibold">
                Terms and conditions accepted successfully.
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  )
}

export default TermsConditions
